import React from 'react';

export const HelpIcon = (props) => {
  return (
    <svg
      {...props}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.7"
        d="M10 4.04443C8.64026 4.04443 7.31105 4.44765 6.18046 5.20308C5.04987 5.95851 4.16868 7.03224 3.64833 8.28849C3.12798 9.54473 2.99183 10.9271 3.2571 12.2607C3.52238 13.5943 4.17716 14.8193 5.13865 15.7808C6.10013 16.7423 7.32514 17.3971 8.65876 17.6623C9.99238 17.9276 11.3747 17.7915 12.631 17.2711C13.8872 16.7508 14.9609 15.8696 15.7164 14.739C16.4718 13.6084 16.875 12.2792 16.875 10.9194C16.875 9.09607 16.1507 7.34739 14.8614 6.05807C13.5721 4.76876 11.8234 4.04443 10 4.04443Z"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
      <path
        opacity="0.8"
        d="M7.8125 8.82119C7.8125 8.82119 7.84531 8.1376 8.57695 7.54893C9.01094 7.19932 9.53125 7.09815 10 7.09112C10.427 7.08565 10.8082 7.15635 11.0363 7.26494C11.427 7.45088 12.1875 7.90479 12.1875 8.87002C12.1875 9.88565 11.5234 10.347 10.7668 10.8544C10.0102 11.3618 9.80469 11.9126 9.80469 12.4817"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        opacity="0.8"
        d="M9.76562 15.2944C10.1971 15.2944 10.5469 14.9447 10.5469 14.5132C10.5469 14.0817 10.1971 13.7319 9.76562 13.7319C9.33415 13.7319 8.98438 14.0817 8.98438 14.5132C8.98438 14.9447 9.33415 15.2944 9.76562 15.2944Z"
        fill="currentColor"
      />
    </svg>
  );
};
